// frontend/src/components/Timeline.js
import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, RocketLaunchIcon, StarIcon } from '@heroicons/react/24/outline';

const Timeline = ({ settings }) => {
    const items = [
        {
            icon: (
                <svg className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
            ),
            title: "Место проведения",
            content: settings.place || 'Уточняется',
        },
        {
            icon: (
                <svg className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 8v4l3 3m6-3a9 9 0 01-18 0 9 9 0 0118 0z" />
                </svg>
            ),
            title: "Время сбора гостей (GMT+3)",
            content: settings.gathering_time ? `${settings.gathering_time}` : 'Уточняется',
        },
        {
            icon: <RocketLaunchIcon className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12" />,
            title: "Начало банкета (GMT+3)",
            content: settings.ceremony_time || 'Уточняется',
        },
        {
            icon: <StarIcon className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12" />,
            title: "Особенности",
            content: settings.details || 'Будет объявлено позже',
        },
        {

            icon: (
                <svg className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12" fill="none" stroke="currentColor"
                     viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
            ),
            title: "Гостевой ТГ чат",
            content: settings.tg_chat_link ? (
                <a
                    href={settings.tg_chat_link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gold-accent hover:underline font-medium"
                >
                    Присоединиться к чату →
                </a>
            ) : 'Будет создан ближе к дате',
        },
        {
            icon: (
                <svg className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M3 8l7.89 5.26a2.01 2.01 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2" />
                </svg>
            ),
            title: "Кому писать в случае вопросов",
            content: settings.contact_person && settings.contact_info ? (
                <span className="font-medium">
                    {settings.contact_person}<br/>
                    <a
                        href={settings.contact_info}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-gold-accent hover:underline font-medium"
                    >
                    Написать в ТГ →
                </a>
                </span>
            ) : 'Уточняется',
        },
    ];

    return (
        <section className="relative py-12 sm:py-16 md:py-20 px-4 bg-gray-50 overflow-hidden" id="details">
            <div className="max-w-6xl mx-auto relative z-10">
                <motion.div
                    className="text-center mb-8 sm:mb-12 md:mb-16"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                >
                    <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-display mb-3 sm:mb-4 px-2">
                        Празднуем нашу любовь с теми, кто нам дорог
                    </h2>
                    <p className="text-gray-600 text-sm sm:text-base max-w-2xl mx-auto px-2">
                        Важная информация о мероприятии
                    </p>
                </motion.div>

                <div className="grid grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                    {items.map((item, index) => (
                        <motion.div
                            key={index}
                            className="bg-white p-6 sm:p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 flex flex-col items-center text-center group"
                            initial={{opacity: 0, y: 30}}
                            whileInView={{opacity: 1, y: 0}}
                            viewport={{once: true}}
                            transition={{delay: index * 0.08}}
                        >
                            <div
                                className="mb-5 text-gold-accent group-hover:scale-110 transition-transform duration-300">
                                {item.icon}
                            </div>
                            <h3 className="text-xl font-display mb-3">{item.title}</h3>
                            <div className="text-gray-600 text-[15px] leading-relaxed">
                                {item.content}
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Timeline;